// extracted by mini-css-extract-plugin
export default {"boardSubtitle":"h_WuuA"};